import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import VerifactuContent from './components/VerifactuContent';

const Verifactu = () => {

    return (
        <>

            <TemplateDashboard>
                <VerifactuContent />
            </TemplateDashboard>

        </>
    )
};

export default Verifactu;